import React from "react";

/**
 * Destination logos for the Automate pill, inlined as SVG so the pill renders
 * identically to the Lovable reference (no remote favicon fetch, no raster
 * asset scaling at 14px).
 */
const SlackLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <path
      fill="#E01E5A"
      d="M5.04 15.16a2.04 2.04 0 1 1-2.04-2.04h2.04zM6.06 15.16a2.04 2.04 0 1 1 4.08 0v5.1a2.04 2.04 0 1 1-4.08 0z"
    />
    <path
      fill="#36C5F0"
      d="M8.1 5.04a2.04 2.04 0 1 1 2.04-2.04v2.04zM8.1 6.06a2.04 2.04 0 1 1 0 4.08H3a2.04 2.04 0 1 1 0-4.08z"
    />
    <path
      fill="#2EB67D"
      d="M18.96 8.1a2.04 2.04 0 1 1 2.04 2.04h-2.04zM17.94 8.1a2.04 2.04 0 1 1-4.08 0V3a2.04 2.04 0 1 1 4.08 0z"
    />
    <path
      fill="#ECB22E"
      d="M15.9 18.96a2.04 2.04 0 1 1-2.04 2.04v-2.04zM15.9 17.94a2.04 2.04 0 1 1 0-4.08H21a2.04 2.04 0 1 1 0 4.08z"
    />
  </svg>
);

const TeamsLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden>
    <rect x="2" y="6" width="13" height="12" rx="2" fill="#5059C9" />
    <text
      x="8.5"
      y="15.5"
      textAnchor="middle"
      fontSize="9"
      fontWeight="700"
      fill="#fff"
      fontFamily="Arial"
    >
      T
    </text>
    <circle cx="19" cy="9" r="3" fill="#7B83EB" />
    <rect x="15.5" y="11" width="7" height="7" rx="1.5" fill="#7B83EB" />
  </svg>
);

// Keyed by the provider id the task form stores in `output`.
const LOGOS = {
  slack: SlackLogo,
  "microsoft-teams": TeamsLogo,
};

const ChannelLogo = ({ provider, className = "h-3.5 w-3.5" }) => {
  const Logo = LOGOS[String(provider || "").toLowerCase()];
  if (!Logo) return null;
  return <Logo className={className} />;
};

export const CHANNEL_PROVIDERS = Object.keys(LOGOS);

export default ChannelLogo;
